import { Landing } from "../pages/landing/Landing";

export const guestRoutes = [
  {
    path: "/",
    component: <Landing />,
  },
];
